import { SCHEDULING_ASSISTANT_ONBOARDING_STATE_SETTING_NAME } from './api'

export const getSchedulingAssistantSettingValueByName = (schedulingAssistantSettings, settingName) => {
  const safeSchedulingAssistantSettings = Array.isArray(schedulingAssistantSettings) ? schedulingAssistantSettings : []
  return safeSchedulingAssistantSettings.find((setting) => setting.settingName === settingName)?.settingValue
}

/**
 * Parses `ai_exec_assistant_onboarding_state` (JSON string) and returns `is_complete`.
 * Missing / invalid values are treated as incomplete.
 */
export const getSchedulingAssistantOnboardingIsComplete = (schedulingAssistantSettings) => {
  const rawValue = getSchedulingAssistantSettingValueByName(
    schedulingAssistantSettings,
    SCHEDULING_ASSISTANT_ONBOARDING_STATE_SETTING_NAME
  )
  if (!rawValue) return false

  try {
    const parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue
    return parsed?.is_complete === true
  } catch {
    return false
  }
}
